import React from 'react';

const PurchasesArchiveTab = ({ isCollapsed }) => {
    return (
        <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
            <article className="users">
                <div className="clients-table clients-table--purchase-archive">
                    <div className="clients-table__header">
                        <div className="clients-table__row">
                            <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                Архив закупок пока пуст
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    );
};

export default PurchasesArchiveTab;
